<template>
	<div class="small-12" v-if="loaded">
		<pie-chart-js :chart-data="chartData" :options="chartOptions"></pie-chart-js>
	</div>
</template>

<script>
	
	// Import the charts
	import PieChartJs from '@/assets/js/charts/Pie.js'

	export default {

		/*
		** Set the component name
		*/

		name: 'PieChart',

		/*
		**  Register the components
		*/

		components: {

			PieChartJs

		},

		/*
		**  Set up the data
		*/

		data: () => ({

			loaded: false

		}),

		/*	
		**  Get the props
		*/

		props: {
			chartData: {
				type: Object,
				default: () => null
			},
			chartOptions: {
				type: Object,
				default: () => null
			}
		},

		/*
		**  Watch em'
		*/

		watch: {

			chartData: {

				immediate: true, // Load on created
				handler(chartData) {

					if (chartData) {

						// Set the prop
						this.loaded = true;

					}

				}

			}

		}

	}

</script>